<!--
 * @Author: your name
 * @Date: 2020-04-22 13:48:37
 * @LastEditTime: 2020-05-02 11:28:29
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /contractorBackground/src/views/applicationManagement/videoMonitor/userInfoManage/componments/systermAuthMenuTemplate.vue
 -->
<template>
  <div class="wrapper">
    <div
      class="item_menu"
      v-for="(item, index) in dataArray"
      :key="index"
      @click="menuCkicked(index)"
    >
      <div class="item_label" :class="{ selected_item: curentSelectIndex === index }">
        {{ item }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      curentSelectIndex: 0,
      dataArray: ['系统管理菜单权限', '数据权限']
    };
  },
  methods: {
    menuCkicked(index) {
      this.curentSelectIndex = index;
      let dict = {
        index: index
      };
      this.$emit('systermAuthorMenuClicked', dict);
    }
  }
};
</script>

<style scoped>
.wrapper {
  height: 100%;
  overflow: hidden;
  background: white;
  padding-left: 0px;
  padding-right: 0px;
}

.item_menu {
  height: 48px;
  width: 100%;
  cursor: pointer;
  border-bottom: 1px solid rgba(0, 0, 0, 0.09);
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  align-items: center;
}

.item_label {
  height: 40px;
  width: 100%;
  line-height: 40px;
  padding-left: 15px;
  padding-right: 15px;
  color: #333333;
  background: white;
  font-size: 14px;
}

.selected_item {
  color: #ffffff;
  background: #1890ff;
}
</style>
